import { render, staticRenderFns } from "./CollectDetailDefaultLayout.vue?vue&type=template&id=54832f76&scoped=true"
import script from "./CollectDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CollectDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54832f76",
  null
  
)

export default component.exports